export default "__VITE_ASSET__Dv027SI8__"